// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__zzePy","link":"tweet-replies_link__S2BKO","text":"tweet-replies_text__tegEH"};